import React from 'react';
import './Footer.css';
import footer_logo from '../Assets/footer_logo.jpg';
import whatsapp from '../Assets/whatsapp_icon.png';
import facebook from '../Assets/facebook.png';
import '@fortawesome/fontawesome-free/css/all.min.css';


const Footer = () => {
  return (
    <div className='footer'>
        <div className="footer-logo">
            <img src={footer_logo} alt=''></img>
            <p>Sairam Foods</p>
        </div>
        <ul className="footer-links">
            {/* <li>About</li> */}
            <li><strong>Contact</strong></li>
        </ul>

        <div className="footer-contact-details">
            <p><strong>Address:</strong> 17 Trelawny Terrace, Grenada Village, Wellington</p>
            <p><strong>Phone:</strong> <a href="tel:+64274423866">0274423866</a></p>
            <p><strong>Email:</strong> <a href="mailto:sairamtradersnz@gmail.com">sairamtradersnz@gmail.com</a></p>

            <p>
                <a href="https://www.google.com/maps?q=17+Trelawny+Terrace,+Grenada+Village,+Wellington" target="_blank" rel="noopener noreferrer">
                    <button className="get-directions-btn">
                        <i className="fas fa-map-marker-alt map-icon"></i> Get Directions
                    </button>
                </a>
            </p>
        </div>

        {/* <div className="footer-social-icon">
            <div className="footer-icons-container">
                <img src={facebook} alt='' />
            </div>
            <div className="footer-icons-container">
                <img src={whatsapp} alt='' />
            </div>
        </div> */}

        <div className="footer-social-icon">
    <div className="footer-icons-container">
        <a href="https://www.facebook.com/Karthikeyan0312" target="_blank" rel="noopener noreferrer">
            <img src={facebook} alt="Facebook" />
        </a>
    </div>
    <div className="footer-icons-container">
        <a href="https://wa.me/+64274423866" target="_blank" rel="noopener noreferrer">
            <img src={whatsapp} alt="WhatsApp" />
        </a>
    </div>
</div>
    <div className="footer-copyright">
        <hr />
        <p>
            &copy; 2025 Sairam Foods. All rights reserved. 
            <a href="/terms-and-conditions" className="terms-link">Terms and Conditions</a>
        </p>
    </div>
    </div>
  )
}

export default Footer